body {
  height: 100%;
}
:global(#root) > div[style*="hidden"] {
  height: 100vh;
}
.contactMapIframe {
  max-width: 100%;
  height: 300px;
}

.block {
  display: block;
}

.flex {
  display: flex;
}
.flexWrap {
  flex-wrap: wrap;
}
.flexColumn {
  flex-direction: column;
}

.noWrap {
  white-space: nowrap;
}

.alignCenter {
  align-items: center;
}

.alignStart {
  align-items: start;
}

.alignTop {
  align-items: top;
}

.spaceBetween {
  justify-content: space-between;
}

.justifyCenter {
  justify-content: center;
}

.fullHeight {
  height: 100%;
}

.fullWidth {
  width: 100%;
}

.maxWidth150 {
  max-width: 150px;
}

.halfWidth {
  width: 50%;
}

.thirdWidth {
  width: 30%;
}

.shrink0 {
  flex-shrink: 0;
}

.grow1 {
  flex-grow: 1;
}

.mt12 {
  margin-top: 12px;
}

.mt30 {
  margin-top: 30px;
}

.mt40 {
  margin-top: 40px;
}

.mb0 {
  margin-bottom: 0px !important;
}

.mb4 {
  margin-bottom: 4px;
}

.mb6 {
  margin-bottom: 6px;
}

.mb10 {
  margin-bottom: 10px;
}

.mb12 {
  margin-bottom: 12px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt30 {
  margin-top: 30px;
}

.mb0 {
  margin-bottom: 0px !important;
}

.mb6 {
  margin-bottom: 6px;
}

.mb12 {
  margin-bottom: 12px;
}

.mb16 {
  margin-bottom: 16px;
}

.mb20 {
  margin-bottom: 20px !important;
}

.mb30 {
  margin-bottom: 30px !important;
}

.mb40 {
  margin-bottom: 40px !important;
}

.mbn1 {
  margin-bottom: -1px !important;
}

.ml6 {
  margin-left: 6px;
}

.ml16 {
  margin-left: 16px;
}

.mln6 {
  margin-left: -6px !important;
}

.mln10 {
  margin-left: -10px !important;
}

.mr0 {
  margin-right: 0px !important;
}

.mr6 {
  margin-right: 6px;
}

.mrn6 {
  margin-right: -6px !important;
}

.mr12 {
  margin-right: 12px;
}

.mr30 {
  margin-right: 30px;
}

.border {
  border: 1px solid var(--pm-grey11);
}
:global(.dark) {
  .border {
    border: 1px solid var(--pm-grey3);
  }
}
.br4 {
  border-radius: 4px;
}
.br6 {
  border-radius: 6px;
}
.p12 {
  padding: 12px;
}
.p16 {
  padding: 16px;
}
.ph6 {
  padding: 0 6px;
}
